module.exports = __webpack_public_path__ + "media/images/press_kit/azamara/email/top-small-363cca6551b97574cdac79d3e0fa5c8a.png";